import React, {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import Input from "Components/Input";
import {Grid} from "@mui/material";

// Components
import {Form} from "Components";
import Slider from "Components/Slider";
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";

export const ConsecutiveDriving = (props) => {
  const { value, onChange, formRef, triggers, triggersRaw } = props;
  const [formatDate, setFormatDate] = useState({hours:0,mins:30});
  const { messages } = useIntl();
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

  useEffect(() => {
    let minutesExceeded = value?.drivingMinutesExceeded;
    if (value.drivingMinutesExceeded == undefined) {
      onChange({ ...value, drivingMinutesExceeded: 30 });
      minutesExceeded = 30;
    }

    setFormatDate(ToTime(minutesExceeded));
  }, [value]);

  const ToTime = (min) => {
    let hours = Math.floor(min / 60);
    let mins = Math.floor(min - hours * 60);

    return {hours,mins}
  };

  return (
      <Form ref={formRef}
            onSubmit={() => {
                if (value.trigger) {
                    let isValid = triggersRaw?.length > 0

                    if (!isValid) {
                        setShowErrorTrigger(true)
                    } else setShowErrorTrigger(false)
                    return isValid
                }
            }}
      >
          <div className="form-item" style={{padding: "10px 0", marginLeft: '4px'}}>
              <div
                  style={{
                      width: "calc(100% - 200px)",
                      marginBottom: 30,
                      float: "left",
                  }}
              >
                  <label className="input-normal-label">
                      {messages["alertsNewAlert_hoursLabel"]}
                  </label>
                  <Slider
                      min={30}
                      max={1440}
                      value={value.drivingMinutesExceeded}
                      onChange={(event) => {
                          onChange({...value, drivingMinutesExceeded: event});
                      }}
                      sliderOneColor={false}
                      valueLabelDisplay={"off"}
                      sliderStep={15}
                      showValue={false}
                  />
              </div>
              <div style={{width: 180, marginTop: 10, float: 'left', marginLeft: 10}}>
                  <Grid
                      container
                      direction="row"
                      alignItems={"left"}
                      spacing={1}
                  >
                      <Grid item sm={3}>
                          <Input
                              id="consecutiveDrivingHour"
                              placeholder={""}
                              type="number"
                              min={0}
                              max={24}
                              value={formatDate?.hours}
                              className="conDrivingHour"
                              required={false}
                              maxLength={2}
                              onChange={(dateMins) => {
                                  if (dateMins < 24) {
                                      let minutes = (dateMins * 60) + formatDate?.mins;
                                      onChange({...value, drivingMinutesExceeded: minutes});
                                  } else if (dateMins == 24) {
                                      onChange({...value, drivingMinutesExceeded: 1440});
                                  }
                              }}
                          />
                      </Grid>
                      <Grid item sm={3} style={{paddingTop: 25}}>
                          <label className="input-normal-label">{messages["Hours"]}</label>
                      </Grid>
                      <Grid item sm={3}>
                          <Input
                              id="consecutiveDrivingMinutes"
                              placeholder={""}
                              type="number"
                              className="conDrivingHour"
                              maxLength={2}
                              min={0}
                              required={false}
                              max={59}
                              value={formatDate?.mins}
                              onChange={(dateMins) => {
                                  if (formatDate?.hours < 1 && dateMins < 30) {
                                      onChange({...value, drivingMinutesExceeded: 30});
                                  } else if (formatDate?.hours < 24) {
                                      let minutes = (dateMins * 1) + (formatDate?.hours * 60)
                                      onChange({...value, drivingMinutesExceeded: minutes});
                                  }
                              }}
                          />
                      </Grid>
                      <Grid item sm={3} style={{paddingTop: 25}}>
                          <label className="input-normal-label">{messages["mins"]}</label>
                      </Grid>
                  </Grid>
              </div>
          </div>
          <div style={{display: 'inline-block', width: '100%'}}>
              <TriggerLandmark config={value} triggers={triggers} triggersRaw={triggersRaw} onChange={onChange} showErrorTrigger={showErrorTrigger}/>
          </div>
      </Form>
  );
};
